export default {
	/**
	 * 导航栏
	 */
	NAV_ABOUT: '关于论坛',
	NAV_NEWS: '新闻中心',
	NAV_ACADEMIC: '学术活动',
	NAV_CHARACTER: '论坛人物',
	NAV_PUBLICATION: '出版物',
	NAV_IMAGE: '影像资源',
	NAV_ANNOUNCEMENT: '通知公告',
	NAV_REGISTRATION: '会员注册系统',
	NAV_DOWNLOAD: '下载PDF',
	/**
	 * 按钮
	 */
	BUTTON_NEXT: '确认',
	BUTTON_PREV: '上一步',
	BUTTON_SKIP: '跳过',
	BUTTON_AGREE: '同意并继续',
	/**
	 * 登录
	 */
	LOGIN_BTN: '登录',
	LOGIN_TITLE: '登录账号',
	LOGIN_INPUT_NAME_PLACEHOLDER: '请输入邮箱',
	LOGIN_INPUT_PWD_PLACEHOLDER: '请输入密码',
	LOGIN_FORGET_PWD: '忘记密码',
	LOGIN_ERROR: '账号不存在或密码错误，请重新输入',
	/**
	 * 忘记密码
	 */
	FORGET_GUIDE: '请输入您的邮箱，以进行密码重设。',
	FORGET_GUIDE2: '已发送密码至邮箱',
	FORGET_GUIDE3: '已发送至您的注册邮箱',
	FORGET_GUIDE4: '请查看邮件并根据提示进行操作',
	/**
	 * 重置密码
	 */
	RESET_PWD: '重置密码',
	RESET_GUIDE: '请输入新密码，以重置密码。密码长度需要在12位或以上、并且包含大写字母、小写字母、数字、特殊字符',
	RESET_NEW_PWD: '请输入新密码',
	RESET_NEW_PWD_AGAIN: '请再次输入新密码',
	RESET_SAVE: '保存并登录',
	RESET_NOT_EQUAL: '两次输入的密码不一致',
	RESET_PASSWORD_INVALID: '密码必须包含大小写字母、数字、特殊字符，且长度不小于12位',
	/**
	 * 进度
	 */
	PROGRESS_1: '基本信息',
	PROGRESS_2: '活动安排',
	PROGRESS_3: '航班信息',
	PROGRESS_4: '住宿信息',
	PROGRESS_5: '注册成功',
	PROGRESS_6: '与会文件',
	/**
	 * 基本信息
	 */
	INFORMATION_TITLE: '基本信息',
	INFORMATION_GUIDE1: '标有 ',
	INFORMATION_GUIDE2: ' 的栏目为必填项',
	INFORMATION_GUIDE3: '备注：上海论坛为邀请制，请尽快完成会议注册以确认参会。',
	INFORMATION_LEFT1_LABEL: '姓',
	INFORMATION_LEFT1_TIP: '请输入您的姓氏',
	INFORMATION_LEFT2_LABEL: '性别',
	INFORMATION_LEFT2_TIP: '请选择您的性别',
	INFORMATION_LEFT2_OPTION1: '男',
	INFORMATION_LEFT2_OPTION2: '女',
	INFORMATION_LEFT2_OPTION3: '其它',
	INFORMATION_LEFT3_LABEL: '出生日期',
	INFORMATION_LEFT4_LABEL: '工作单位',
	INFORMATION_LEFT4_TIP: '请输入您的工作单位(全称)',
	INFORMATION_LEFT5_LABEL: '联系电话',
	INFORMATION_LEFT5_TIP: '请输入您的联系电话',
	INFORMATION_LEFT6_LABEL: '助理姓名',
	INFORMATION_LEFT6_TIP: '请输入助理姓名(选填)',
	INFORMATION_LEFT7_LABEL: '助理联系电话',
	INFORMATION_LEFT7_TIP: '请输入助理联系电话(选填)',
	INFORMATION_RIGHT1_LABEL: '名',
	INFORMATION_RIGHT1_TIP: '请输入您的名字',
	INFORMATION_RIGHT2_LABEL: '国家/地区',
	INFORMATION_RIGHT2_TIP: '请选择国家/地区',
	INFORMATION_RIGHT3_LABEL: '身份证/护照号',
	INFORMATION_RIGHT3_TIP: '请输入您的身份证/护照号',
	INFORMATION_RIGHT4_LABEL: '职位',
	INFORMATION_RIGHT4_TIP: '请输入您的职位',
	INFORMATION_RIGHT5_LABEL: '联系地址',
	INFORMATION_RIGHT5_TIP: '请输入您的联系地址(选填)',
	INFORMATION_RIGHT6_LABEL: '助理邮箱',
	INFORMATION_RIGHT6_TIP: '请输入助理邮箱(选填)',
	INFORMATION_BIRTHDAY_TIP: '请选择您的出生日期',
	/**
	 * 活动安排
	 */
	ACTIVITY_TITLE: '活动安排',
	ACTIVITY_NO_ACCESS: '该活动仅对部分嘉宾开放，详情请咨询上海论坛秘书处',
	ACTIVITY_NO_SELECT: '尚未选择任何活动',
	ACTIVITY_FAV: '请选择您感兴趣的活动参加',
	/**
	 * 航班信息
	 */
	FLIGHT_TITLE: '航班信息',
	FLIGHT_DEADLINE: '4月15日',
	FLIGHT_GUIDE1: '您可以从以下三种方式任选一种来预订您的机票(不可复选)',
	FLIGHT_GUIDE2: '1. 如需会务组代理订票，请于 ',
	FLIGHT_GUIDE3: '前完成信息填写。该日期后，会务组将不再提供订票服务，请自行购票，并按需填写报销信息；',
	FLIGHT_GUIDE4: '2. 若您选择高铁/火车，会务组则不提供代理购票服务，您可自行购票，会务组将根据国家相关财务规定给予报销。请您在下方选择您希望的报销方式，并填写相关信息。论坛结束后，请将您的高铁/火车票原件与身份证/护照复印件邮寄给秘书处以申请报销。',
	FLIGHT_SECTION_TITLE1: '授权上海论坛会务组代理预订机票',
	FLIGHT_SECTION_TITLE2_PRE: '自行购买机票并报销(会议注册现场',
	FLIGHT_SECTION_TITLE2_STRONG: '人民币',
	FLIGHT_SECTION_TITLE2_AFTER: '报销)',
	FLIGHT_SECTION_TITLE3: '自行购买机票并报销(银行转账报销)',
	FLIGHT_SECTION_TITLE4: '自行购买机票，无需报销',
	FLIGHT_GO_TITLE: '去程出发信息',
	FLIGHT_GO_LABEL1: '请确认去程出发城市',
	FLIGHT_GO_LABEL2: '请确认去程出发日期',
	FLIGHT_GO_LABEL3: '请指定出发航班号',
	FLIGHT_RETURN_TITLE: '返程到达信息',
	FLIGHT_RETURN_LABEL1: '请确认返程到达城市',
	FLIGHT_RETURN_LABEL2: '请确认返程出发日期',
	FLIGHT_RETURN_LABEL3: '请指定返程航班号',
	FLIGHT_ATTENTION0: '注：',
	FLIGHT_ATTENTION1: '若您需要预订国际航班，请务必填写护照号，并上传您的护照照片页扫描件；',
	FLIGHT_ATTENTION2: '若您需要使用护照号预订国内航班，请务必填写护照号，并上传您的护照照片页扫描件；',
	FLIGHT_ATTENTION3: '论坛仅承担嘉宾所在地与会议地(上海)之间的往返机票或高铁票，签证费、往返机场/火车站的出租车费用等其他费用将不予承担；',
	FLIGHT_WARN: '机票确定出票后，如无特殊情况，因嘉宾自身原因而产生的退票费、改签费等费用需由嘉宾自行承担。',
	FLIGHT_UPLOAD1: '点击添加护照照片页',
	FLIGHT_UPLOAD2: '点击添加电子客票行程单',
	FLIGHT_CASH_GUIDE1: '您可自行购买往返/单程机票，若需会务组代理预订单程机票，请发送邮件至shanghaiforum@fudan.edu.cn；',
	FLIGHT_CASH_GUIDE2: '若您选择人民币现金报销，请在购票后及时上传您的电子客票行程单，论坛将根据电子行程单上的价格给予报销。若超过报销上限，则按上限金额予以报销。请在论坛注册现场向工作人员提交您的登机牌原件与身份证/护照复印件申请报销；',
	FLIGHT_CASH_GUIDE3: '论坛仅承担往返经济舱机票费用（不包括超级经济舱）。若您自行购买其他舱位，需提供购票时同航班经济舱报价，若未超过报销上限，将参考经济舱报价金额给予报销；',
	FLIGHT_CASH_GUIDE4: '机票报销上限：',
	FLIGHT_CASH_GUIDE41_PRE: '1) 中国国内（含港澳台）报销上限为',
	FLIGHT_CASH_GUIDE41_CONTENT: '3000人民币',
	FLIGHT_CASH_GUIDE41_AFTER: '（往返）',
	FLIGHT_CASH_GUIDE42_PRE: '2) 亚洲地区报销上限为',
	FLIGHT_CASH_GUIDE42_CONTENT: '6000人民币',
	FLIGHT_CASH_GUIDE42_AFTER: '（往返）',
	FLIGHT_CASH_GUIDE43_PRE: '3) 其它地区报销上限为',
	FLIGHT_CASH_GUIDE43_CONTENT: '12000人民币',
	FLIGHT_CASH_GUIDE43_AFTER: '（往返）',
	FLIGHT_TRANSFER_GUIDE2: '若您选择银行转账报销，请在购票后及时上传您的电子客票行程单并填写转账信息。论坛将根据电子行程单上的价格给予报销。请在论坛注册现场向工作人员提交您的登机牌原件与身份证/护照复印件申请报销；',
	FLIGHT_ALERT: '请同意备注下方条款',
	FLIGHT_START: '开始时间',
	FLIGHT_END: '结束时间',
	FLIGHT_NO: '指定航班号',
	FLIGHT_SPAN: '选择时间段',
	FLIGHT_TIME_COMPARE: '开始时间不能晚于结束时间',
	/**
	 * 酒店信息
	 */
	HOTEL_TITLE: '住宿信息',
	HOTEL_SUBTITLE: '会务组将在论坛指定酒店为您预订一个房间',
	HOTEL_GUIDE1: '为确保酒店房间，请于 ',
	HOTEL_GUIDE2: ' 前填写住宿信息；',
	HOTEL_GUIDE3: ' 4 月 15 日 ',
	HOTEL_GUIDE4: '上海论坛大会默认只预订一个房间，如有疑问，请联系上海论坛。',
	HOTEL_GUIDE5: '论坛将承担公费嘉宾最多4晚（5月8日至11日）的住宿费用（含早餐，不含其它费用），额外住宿或其他费用需您退房时自行结算；',
	HOTEL_GUIDE6: '论坛可为自费嘉宾预订酒店房间，您可在退房时结算；',
	HOTEL_GUIDE7: '酒店离店截止时间、预授权等事项以酒店相关章程为准。',
	HOTEL_LABEL1: '请选择入住日期',
	HOTEL_LABEL2: '请选择离店日期',
	HOTEL_LABEL3: '备注',
	HOTEL_LABEL4: '其它特殊要求请备注',
	HOTEL_LABEL5: '酒店入住日期',
	HOTEL_LABEL6: '酒店离店日期',
	HOTEL_TIP: '离店日期不能早于入住日期',
	/**
	 * 与会文件
	 */
	DOCUMENT_TITLE: '与会文件',
	DOCUMENT_DEADLINE: '2020年05月01日',
	DOCUMENT_GUIDE2: '组委会将整理您上传的发言摘要与论文，作为会议材料，将在论坛期间发放给所有嘉宾；',
	DOCUMENT_GUIDE3: '组委会将整理您上传的发言摘要、论文以及您的公开演讲内容，可能会将其发布至论坛官网等非营利性平台，并可能进行非营利性出版；',
	DOCUMENT_GUIDE4: '论坛将全程摄像与录像，相关照片与视频内容将公开发布至论坛官网等非营利平台；',
	DOCUMENT_GUIDE5: '论坛组委会默认您同意上述所有内容的出版与发布，如果您有任何问题，可发送邮件至 shanghaiforum@fudan.edu.cn；',
	DOCUMENT_GUIDE6: '请您及时填写发言题目，上传论坛、发言摘要与发言PPT，以帮助会议的顺利筹备，感谢您的支持！',
	DOCUMENT_LABEL1: '演讲题目',
	DOCUMENT_TIP1: '请填写您的演讲题目',
	DOCUMENT_SECTION_TITLE1: "上传论文",
	DOCUMENT_SECTION_TITLE2: "上传摘要",
	DOCUMENT_SECTION_TITLE3: "上传演讲PPT",
	DOCUMENT_REQUIREMENTS_TITLE1: '论文要求',
	DOCUMENT_REQUIREMENTS_TITLE2: '摘要要求',
	DOCUMENT_REQUIREMENTS_TITLE3: '演讲PPT要求',
	DOCUMENT_REQUIREMENTS1: '语言为中文或英文；',
	DOCUMENT_REQUIREMENTS1_SUMMARY: '语言为中文或英文；',
	DOCUMENT_REQUIREMENTS1_PPT: '语言为英文或中英双语；',
	DOCUMENT_REQUIREMENTS2: '须包含摘要和关键词；',
	DOCUMENT_REQUIREMENTS3: '字数（含摘要）：中文不少于5000字，英文不少于3000词；',
	DOCUMENT_REQUIREMENTS4: '内容需与子论坛/圆桌主题密切相关，并展示您对该主题研究的最新观点；',
	DOCUMENT_REQUIREMENTS5: '上传的文件格式须为.doc、.docx 或 .pdf，文件大小须小于10M',
	DOCUMENT_REQUIREMENTS5_1: '上传的文件格式须为.doc、.docx，文件大小须小于10M',
	DOCUMENT_REQUIREMENTS6: '内容为您发言内容的简要概括；',
	DOCUMENT_REQUIREMENTS7: '字数：中文500字、英文300词以内；',
	DOCUMENT_REQUIREMENTS8: '论坛组委会将制作《嘉宾发言摘要与论文集》，在论坛期间向所有主席与嘉宾发放；',
	DOCUMENT_REQUIREMENTS9: '内容为您会上发言时需使用的PPT；',
	DOCUMENT_REQUIREMENTS10: '提前上传发言PPT可帮助提高现场同传的质量，提高会议讨论质量；若您无法提前上传，需现场拷贝，请发送邮件至 shanghaiforum@fudan.edu.cn，提前告知组委会；',
	DOCUMENT_REQUIREMENTS11: '上传的文件格式须为.ppt、.pptx 或 .pdf，文件大小须小于 20M',
	DOCUMENT_NOT_SUPPORT: '不支持当前文件格式',
	DOCUMENT_DIALOG_TITLE: '特别提醒',
	DOCUMENT_DIALOG_CONTENT1: '1.您上传的发言摘要与论文，经整理后将作为会议材料，在论坛期间发放给所有嘉宾；',
	DOCUMENT_DIALOG_CONTENT2: '2.您上传的发言摘要、论文以及您的公开演讲内容，可能会发布至论坛官网等非营利性平台，并可能进行非营利性出版；',
	DOCUMENT_DIALOG_CONTENT3: '3.论坛将全程摄像与录像，相关照片与视频内容将公开发布至论坛官网等非营利性平台。',
	DOCUMENT_DIALOG_CONTENT4: '如您对上述授权内容有异议，可在会前通过邮件与上海论坛秘书处沟通，邮箱地址shanghaiforum@fudan.edu.cn。',
	DOCUMENT_DIALOG_CONTENT5: '非常感谢！',
	DOCUMENT_DIALOG_BUTTON: '确认',
	/**
	 * 汇总页
	 */
	SUMMARY_EDIT: '编辑',
	SUMMARY_PAPER: '论文',
	SUMMARY_ABSTRACT: '摘要',
	SUMMARY_CHECK_IN: '入住时间',
	SUMMARY_CHECK_OUT: '退房时间',
	SUMMARY_FLIGHT1: '去程信息',
	SUMMARY_FLIGHT1_1: '出发城市',
	SUMMARY_FLIGHT1_2: '出发时间',
	SUMMARY_FLIGHT2: '返程信息',
	SUMMARY_FLIGHT2_1: '到达城市',
	SUMMARY_FLIGHT2_2: '返程时间',
	SUMMARY_FLIGHT_NO: '航班号',
	SUMMARY_FLIGHT_OWN: '自行购买机票，无需报销',
	SUMMARY_CONFIRM: '请先完成基本信息的编辑',
	SUMMARY_CONFIRM_OK: '编辑基本信息',
	SUMMARY_ITINERARY: '电子客票行程单',
	/**
	 * 通用
	 */
	NEXT: '下一步',
	TIP_WAITING: '请稍候',
	TIP_EMAIL_WRONG: '邮箱格式不正确',
	TIP_EMAIL_REQUIRED: '请输入邮箱',
	TIP_PWD_REQUIRED: '请输入密码',
	TIP_OVER_SIZE: '所选文件大小超过限制，请重新选择',
	TIP_OVER_SIZE2: '文件大小须小于20M',
	TIP_NOT_FILLED: '未填写',
	TIP_REQUIRED: '请填写此项',
	TIP_CHANGE_PASSWORD: ' 修改密码',
	TIP_LOGOUT: '退出',
	TIP_PROTOCOL: '服务协议',
	TIP_CANCEL: '取消',
	TIP_CONFIRM: '确认',
	TIP_DELETE: '是否确认删除?',
	TIP_DELETE_YES: '确认',
	TIP_DELETE_NO: '取消',
	/**
	 * 悬浮菜单
	 */
	SIDE_MENU_BOOK: '会议手册',
	SIDE_MENU_GUIDE: '会议指南',
	SIDE_MENU_QA: 'FAQ'
};
